module.exports = __webpack_public_path__ + "static/img/qishou.3573c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/deliveryDetail/qishou.png
// module id = 5GzF
// module chunks = 1